module.exports = __webpack_public_path__ + "static/media/da-vinci-ice.7c27b95f.jpg";